import { gql } from '@apollo/client';

const GET_SCRIPT_VIEWS_V2 = gql`
  query {
    getScriptViewsV2 {
        id
        name
        viewCondition
        customView
        shared
        systemViewProperty
    }
  }
`;

const GET_INTERESTED_COMMUNITY_SCRIPT_TAGS = gql`
  query {
    getInterestedCommunityScriptTags
  }
`;

const GET_COMMUNITY_SCRIPT_TAGS = gql`
  query ($includeFavTags:Boolean, $listInfo: ListInfoInput!) {
    getCommunityScriptTags(includeFavTags:$includeFavTags,listInfo: $listInfo){
      tags
    }
  }
`;

const GET_COMMUNITY_LIBRARY_SCRIPTS = gql`
  query ($listInfo: ListInfoInput) {
    getCommunityLibraryScripts(listInfo: $listInfo) {
      communityScripts {
        name
        description
        scriptId
        publishedUserName
        addedTime
        isImported
        isShared
        isUpVotedByCurrentUser
        upVoteCount
        importCount
        language
      }
      listInfo {
        totalCount
        sort {
          attribute
          order
        }
        page
        pageSize
      }
    }
  }
`;

const UPVOTE_SCRIPT = gql`
  mutation($scriptId: ID!, $upvote: Boolean) {
    voteScript(scriptId: $scriptId, upvote: $upvote)
  }
`;

const GET_ASSET_SCRIPT_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getAssetScriptList(listInfo: $listInfo) {
      assetScripts {
        scriptId
        name
        description
        language
        addedBy {
          name
        }
        createdTime
        favourite
        imported
        shared
        tags
        readMe
      }
      listInfo {
        totalCount
        sort {
          attribute
          order
        }
        page
        pageSize
      }
    }
  }
`;

const GET_COMMUNITY_SCRIPT = gql`
  query($scriptId: ID!){
    getCommunityScript(scriptId: $scriptId){
        scriptId
        name
        language
        fileName
        description
        runAs
        timeOut
        upVoteCount
        importCount
        isVerified
        content
        isImported
        isShared
        publishedUserName
        publishedUserId
        publishedCustomerId
        isUpVotedByCurrentUser
        addedTime
        updatedTime
        scriptVariables
        tags
        readMe
    }
  }
`;

const IMPORT_COMMUNITY_SCRIPT = gql`
  mutation ($scriptId: ID!) {
    importCommunityScript(scriptId:$scriptId)
  }
`;

const SHARE_TO_COMMUNITY_SCRIPT_LIBRARY = gql`
  mutation ($scriptId: ID!) {
    shareToCommunityScriptLibrary(scriptId:$scriptId)
  }
`;

const UPDATE_INTERESTED_COMMUNITY_SCRIPT_TAGS = gql`
  mutation updateInterestedCommunityScriptTags($interestedTags:InterestedScriptTagInput){
    updateInterestedCommunityScriptTags(interestedTags:$interestedTags)
  }
`;

const SYNC_COMMUNITY_SCRIPT = gql`
  mutation ($scriptId: ID!) {
    syncChangesToCommunityScript(scriptId:$scriptId)
  }
`;

const UPDATE_COMMUNITY_SCRIPT_CHANGES = gql`
  mutation ($scriptId: ID!) {
    updateCommunityScriptChangesToAssetScript(scriptId:$scriptId)
  }
`;

const REMOVE_COMMUNITY_SCRIPT_CHANGES = gql`
  mutation ($scriptId: ID!) {
    removeFromCommunityScriptLibrary(scriptId:$scriptId)
  }
`;

export {
  GET_SCRIPT_VIEWS_V2,
  GET_COMMUNITY_SCRIPT_TAGS,
  GET_INTERESTED_COMMUNITY_SCRIPT_TAGS,
  GET_COMMUNITY_LIBRARY_SCRIPTS,
  GET_ASSET_SCRIPT_LIST,
  UPVOTE_SCRIPT,
  GET_COMMUNITY_SCRIPT,
  IMPORT_COMMUNITY_SCRIPT,
  SHARE_TO_COMMUNITY_SCRIPT_LIBRARY,
  UPDATE_INTERESTED_COMMUNITY_SCRIPT_TAGS,
  SYNC_COMMUNITY_SCRIPT,
  UPDATE_COMMUNITY_SCRIPT_CHANGES,
  REMOVE_COMMUNITY_SCRIPT_CHANGES
}